import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import NoAccessPage from "@components/common/NoAccess";
import { NavLink } from "react-router-dom";
import "./styles.scss";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { getSmartFilterListManagementListIC } from "@services/internal-compliance.service";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import InputField from "@_common/InputRuleFeild";
import ConfigurePopup from "@pages/Checkpoint/AssignedTasksList/popup/configure";
import { convertDate, getDiffInDates } from "@_common/date-helpers";
import { toast } from "react-toastify";
import {
  configureSelfComplianceIC,
  getSpecificSelfComplianceListIC,
} from "@services/internal-compliance.service";
import { useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { formatDate } from "@_common/format-date";
import { convertStringToNumber } from "@_common/format-text";
import AssignedTaskImpactSvgComponent from "../../../../../../../src/assets/svg-components/assigned-task-impact";
import AssignedTaskFrequencySvgComponent from "../../../../../../../src/assets/svg-components/assigned-task-frequency";
import AssignedTaskDueDateSvgComponent from "../../../../../../../src/assets/svg-components/assigned-task-duedate";
import EditGreySvgComponent from "../../../../../../assets/svg-components/edit";
import { sanitizeInput } from "@_common/dompurify";

interface IICAssignedTaskConfigurationProps {}

const ICAssignedTaskConfiguration: React.FunctionComponent<IICAssignedTaskConfigurationProps> = (
  props: any
) => {
  let navigate = useNavigate();
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    is_configured: true,
    impact: "",
    impact_on_vertical: "",
    impact_on_unit: "",
    document_required: true,
    // history_required: true,
    task_type: "STANDARD",
    email_buffer_days: "",
    days_buffer: "",
    // owner_alert_prior_day: "",
    frequency_type: "ONE_TIME",
    new_activity_range: "DAILY",
    once_in_every: 0,
    on_day: 0,
    on_month: 0,

    back_dates_allowed: false,
    task_maker_checker_allowed: false,
    enable_audit_step: false,

    legal_due_date: null,
    // unit_head_due_date: null,
    function_head_due_date: null,
    approver_due_date: null,
    owner_due_date: null,
    // audit_date: null,

    first_alert_date: null,
    second_alert_date: null,
    third_alert_date: null,
    fourth_alert_date: null,
    fifth_alert_date: null,
    sixth_alert_date: null,
  });
  const [additionalAlert, setAdditionalAlert] = useState(true);
  const [subTaskList] = useState([
    { value: "STANDARD", label: "Standard (Default)" },
    { value: "SUB_TASK", label: "Enable Sub-Task" },
    { value: "EVENT_BASED", label: "Mark as Event Based" },
  ]);

  const [alertDates, setAlertDates] = useState([
    { type: "first_alert_date", label: "First Alert Date", date: null },
    { type: "second_alert_date", label: "Second Alert Date", date: null },
    { type: "third_alert_date", label: "Third Alert Date", date: null },
    { type: "fourth_alert_date", label: "Fourth Alert Date", date: null },
    { type: "fifth_alert_date", label: "Fifth Alert Date", date: null },
    { type: "sixth_alert_date", label: "Sixth Alert Date", date: null },
  ]);

  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    if (props.permissionAPITriggered) {
      getImpactOnVerticalList("");
      getImpactOnUnitList("");
      getImpactList("");
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("self_compliance_ids[]");
    if (getValue(selectedIDs, `length`, 0) === 1) {
      getSpecificSelfComplianceInfo(getValue(selectedIDs, `[${0}]`, ""));
    }
  }, [props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getSpecificSelfComplianceInfo = async (id: string) => {
    try {
      let resp = await getSpecificSelfComplianceListIC(id);
      if (resp) {
        // if(getValue(resp,`data.is_configured`,false)){
        setRequest({
          ...request,
          impact: getValue(resp, `data.impact.id`, ""),
          impact_on_vertical: getValue(resp, `data.impact_on_vertical.id`, ""),
          impact_on_unit: getValue(resp, `data.impact_on_unit.id`, ""),
          document_required: getValue(resp, `data.document_required`, false),
          // history_required: getValue(resp, `data.history_required`, false),
          task_type: getValue(resp, `data.task_type`, ""),

          days_buffer: getValue(resp, `data.days_buffer`, ""),
          email_buffer_days: getValue(resp, `data.email_buffer_days`, ""),

          // owner_alert_prior_day: getValue(
          // 	resp,
          // 	`data.owner_alert_prior_day`,
          // 	""
          // ),
          frequency_type: getValue(resp, `data.frequency_type`, ""),
          new_activity_range: getValue(resp, `data.new_activity_range`, ""),
          once_in_every: getValue(resp, `data.once_in_every`, ""),
          on_day: getValue(resp, `data.on_day`, ""),
          on_month: getValue(resp, `data.on_month`, ""),
          is_configured: true,
          back_dates_allowed: getValue(resp, `data.back_dates_allowed`, false),
          task_maker_checker_allowed: getValue(
            resp,
            `data.task_maker_checker_allowed`,
            false
          ),
          enable_audit_step: getValue(resp, `data.enable_audit_step`, false),

          legal_due_date: formatDate(
            getValue(resp, `data.legal_due_date`, null)
          ),
          // unit_head_due_date: formatDate(
          // 	getValue(resp, `data.unit_head_due_date`, null)
          // ),
          function_head_due_date: formatDate(
            getValue(resp, `data.function_head_due_date`, null)
          ),
          approver_due_date: formatDate(
            getValue(resp, `data.approver_due_date`, null)
          ),
          owner_due_date: formatDate(
            getValue(resp, `data.owner_due_date`, null)
          ),
          //audit_date: formatDate(getValue(resp, `data.audit_date`, null)),
        });

        let array: any = [
          {
            type: "first_alert_date",
            label: "First Alert Date",
            date: formatDate(getValue(resp, `data.first_alert_date`, null)),
          },
          {
            type: "second_alert_date",
            label: "Second Alert Date",
            date: formatDate(getValue(resp, `data.second_alert_date`, null)),
          },
          {
            type: "third_alert_date",
            label: "Third Alert Date",
            date: formatDate(getValue(resp, `data.third_alert_date`, null)),
          },
          {
            type: "fourth_alert_date",
            label: "Fourth Alert Date",
            date: formatDate(getValue(resp, `data.fourth_alert_date`, null)),
          },
          {
            type: "fifth_alert_date",
            label: "Fifth Alert Date",
            date: formatDate(getValue(resp, `data.fifth_alert_date`, null)),
          },
          {
            type: "sixth_alert_date",
            label: "Sixth Alert Date",
            date: formatDate(getValue(resp, `data.sixth_alert_date`, null)),
          },
        ];

        setAlertDates(array);
        // }
      }
    } catch (error) {}
  };
  /* ---------------------------  Impact On Vertical  ----------------------------- */
  const [impactOnVerticalList, setImpactOnVerticalList] = useState([]);
  const [eventLoading, setEventLoading] = useState(true);
  const getImpactOnVerticalList = async (value: string) => {
    try {
      setRequest({
        ...request,
        impact_on_vertical: "",
      });
      setEventLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        group_code: "impact-on-organization",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterListManagementListIC(queryRequest);
      if (resp) {
        setImpactOnVerticalList(
          getValue(resp, `data.listItems`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          }))
        );
        setEventLoading(false);
      } else {
        setEventLoading(false);
      }
    } catch (error) {
      setEventLoading(false);
    }
    if (!value) {
      setValue(request, `impact_on_vertical`, "");
    }
  };

  /* ---------------------------  Impact On Unit  ----------------------------- */
  const [impactOnUnitList, setImpactOnUnitList] = useState([]);
  const [impactOnUnitLoading, setImpactOnUnitLoading] = useState(false);
  const getImpactOnUnitList = async (value: string) => {
    try {
      setRequest({
        ...request,
        impact_on_unit: "",
      });
      setImpactOnUnitLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        // group_id: "35",
        group_code: "impact-on-unit",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterListManagementListIC(queryRequest);
      if (resp) {
        setImpactOnUnitList(
          getValue(resp, `data.listItems`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          }))
        );
        setImpactOnUnitLoading(false);
      } else {
        setImpactOnUnitLoading(false);
      }
    } catch (error) {
      setImpactOnUnitLoading(false);
    }
    if (!value) {
      setValue(request, `impact_on_unit`, "");
    }
  };
  /* ---------------------------  Impact List  ----------------------------- */

  const [impactList, setImpactList] = useState([]);
  const [impactLoading, setImpactLoading] = useState(false);
  const getImpactList = async (value: string) => {
    try {
      setRequest({
        ...request,
        impact: "",
      });
      setImpactLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        // group_id: "35",
        group_code: "impact",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterListManagementListIC(queryRequest);
      if (resp) {
        setImpactList(
          getValue(resp, `data.listItems`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          }))
        );
        setImpactLoading(false);
      } else {
        setImpactLoading(false);
      }
    } catch (error) {
      setImpactLoading(false);
    }
    if (!value) {
      setValue(request, `impact`, "");
    }
  };

  const handleChangeSelect = (e: any, type: string) => {
    setRequest({
      ...request,
      [type]: getValue(e, `id`, ""),
    });
  };

  const handleRequest = (e: any, name: string) => {
    if (getValue(request, `legal_due_date`, "")) {
      // if (
      // 	name === "owner_alert_prior_day" &&
      // 	parseInt(e.target.value) &&
      // 	getValue(request, `legal_due_date`, "")
      // ) {
      // 	var copiedDate = new Date(getValue(request, `legal_due_date`, ""));
      // 	let date = getDiffInDates(copiedDate, parseInt(e.target.value));
      // 	setRequest({
      // 		...request,
      // 		owner_due_date: date,
      // 		[name]: e.target.value,
      // 	});
      // }
      if (name === "days_buffer" && parseInt(e.target.value) >= 0) {
        var function_head_due_date_main = new Date(
          getValue(request, `legal_due_date`, "")
        );

        // let unit_head_due_date = getDiffInDates(
        // 	function_head_due_date_main,
        // 	parseInt(e.target.value)
        // );

        var function_head_due_date_main = new Date(function_head_due_date_main);
        let function_head_due_date = getDiffInDates(
          function_head_due_date_main,
          parseInt(e.target.value)
        );

        var approver_due_date_main = new Date(function_head_due_date);
        let approver_due_date = getDiffInDates(
          approver_due_date_main,
          parseInt(e.target.value)
        );

        var owner_due_date_main = new Date(approver_due_date);
        let owner_due_date = getDiffInDates(
          owner_due_date_main,
          parseInt(e.target.value)
        );
        setRequest({
          ...request,
          owner_due_date: owner_due_date,
          approver_due_date: approver_due_date,
          function_head_due_date: function_head_due_date,
          // unit_head_due_date: unit_head_due_date,
          [name]: sanitizeInput(e.target.value),
        });
      }
      if (name === "email_buffer_days" && parseInt(e.target.value) >= 0) {
        setRequest({
          ...request,
          [name]: sanitizeInput(e.target.value),
        });
      }
      if (!e.target.value) {
        setRequest({
          ...request,
          [name]: sanitizeInput(e.target.value),
        });
      }
    } else {
      toast.error("Please add legal due date under frequency");
    }
  };
  const handleRequestCalculateDate = (
    e: any,
    name: string,
    days_buffer: any
  ) => {
    if (days_buffer) {
      var function_head_due_date_main = new Date(e);
      var function_head_due_date_main = new Date(function_head_due_date_main);
      let function_head_due_date = getDiffInDates(
        function_head_due_date_main,
        parseInt(days_buffer)
      );
      var approver_due_date_main = new Date(function_head_due_date);
      let approver_due_date = getDiffInDates(
        approver_due_date_main,
        parseInt(days_buffer)
      );
      var owner_due_date_main = new Date(approver_due_date);
      let owner_due_date = getDiffInDates(
        owner_due_date_main,
        parseInt(days_buffer)
      );
      setValue(request, `owner_due_date`, owner_due_date);
      setValue(request, `approver_due_date`, approver_due_date);
      setValue(request, `function_head_due_date`, function_head_due_date);
      setValue(request, `[${name}]`, e);
      setRequest({ ...request });
    } else {
      setValue(request, `[${name}]`, e);
      setRequest({ ...request });
    }
  };
  const handleDate = (e: any, optionIndex: number) => {
    setAlertDates(
      alertDates.map((x, index) => {
        if (index !== optionIndex) return x;
        return {
          ...x,
          date: e,
        };
      })
    );
  };

  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        let selectedAlertDates = alertDates.filter((item) => item.date);
        let alert: any = {};
        for (let key of alertDates) {
          let type = key.type;
          let value = key.date;
          alert[type] = convertDate(value);
        }
        let obj = JSON.parse(JSON.stringify(request));
        const urlSearchParams = new URLSearchParams(window.location.search);
        let selectedIDs: any = urlSearchParams.getAll("self_compliance_ids[]");
        obj["internal_compliance_ids"] = selectedIDs;

        if (getValue(request, `task_type`, "") === "STANDARD") {
          if (getValue(request, `legal_due_date`, null)) {
            obj["legal_due_date"] = convertDate(
              getValue(obj, `legal_due_date`, null)
            );
            obj["approver_due_date"] = convertDate(
              getValue(obj, `approver_due_date`, null)
            );
            obj["function_head_due_date"] = convertDate(
              getValue(obj, `function_head_due_date`, null)
            );
            obj["owner_due_date"] = convertDate(
              getValue(obj, `owner_due_date`, null)
            );
            // obj["unit_head_due_date"] = convertDate(
            // 	getValue(obj, `unit_head_due_date`, null)
            // );
            // obj["audit_date"] = convertDate(getValue(obj, `audit_date`, null));
            obj["is_configured"] = true;
            obj["once_in_every"] = getValue(obj, `once_in_every`, "")
              ? convertStringToNumber(getValue(obj, `once_in_every`, ""))
              : null;
            obj["on_day"] = getValue(obj, `on_day`, "")
              ? convertStringToNumber(getValue(obj, `on_day`, ""))
              : null;
            obj["days_buffer"] = getValue(obj, `days_buffer`, "")
              ? convertStringToNumber(getValue(obj, `days_buffer`, ""))
              : null;
            obj["email_buffer_days"] = getValue(obj, `email_buffer_days`, "")
              ? convertStringToNumber(getValue(obj, `email_buffer_days`, ""))
              : null;

            obj["on_month"] = getValue(obj, `on_month`, "")
              ? convertStringToNumber(getValue(obj, `on_month`, ""))
              : null;

            // Object.keys(obj).forEach((key) => {
            // 	if (!obj[key] || obj[key] === undefined) {
            // 		delete obj[key];
            // 	}
            // });
            setSubmitLoading(true);
            let resp = await configureSelfComplianceIC({ ...obj, ...alert });
            if (resp) {
              setSubmitLoading(false);
              toast.success(getValue(resp, `message`, ""));
              navigate(`/repository/internal-compliance/assigned-tasks`);
            } else {
              setSubmitLoading(false);
            }
          } else {
            toast.error("Please Add Legal Due Date Under Frequency");
          }
        } else {
          // Object.keys(obj).forEach((key) => {
          // 	if (!obj[key] || obj[key] === undefined) {
          // 		delete obj[key];
          // 	}
          // });
          obj["is_configured"] = true;
          setSubmitLoading(true);
          let resp = await configureSelfComplianceIC({ ...obj, ...alert });
          if (resp) {
            setSubmitLoading(false);
            toast.success(getValue(resp, `message`, ""));
            navigate(`/repository/internal-compliance/assigned-tasks`);
          } else {
            setSubmitLoading(false);
          }
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };

  const handleCancel = () => {
    navigate(`/repository/internal-compliance/assigned-tasks`);
  };

  const months = [
    { label: "January", value: "1", id: "1" },
    { label: "February", value: "2", id: "2" },
    { label: "March", value: "3", id: "3" },
    { label: "April", value: "4", id: "4" },
    { label: "May", value: "5", id: "5" },
    { label: "June", value: "6", id: "6" },
    { label: "July", value: "7", id: "7" },
    { label: "August", value: "8", id: "8" },
    { label: "September", value: "9", id: "9" },
    { label: "October", value: "10", id: "10" },
    { label: "November", value: "11", id: "11" },
    { label: "December", value: "12", id: "12" },
  ];

  const getMonthLabel = (value: any) => {
    const monthObj = months.find((month) => month.value === value);
    return monthObj ? monthObj.label : "";
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!eventLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "repository_internal_compliance_assigned_tasks"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex">
            <NavLink to="/repository/internal-compliance/assigned-tasks">
              <img
                src="/images/back-link.svg"
                className="img-fluid"
                height={24}
                width={24}
              />
            </NavLink>
            <h4
              className="dashbaord-wrapper__header-title d-flex"
              style={{ marginLeft: "10px" }}
            >
              Assigned Task Configuration
            </h4>
          </div>
          <div className="task-configuration assigned-task-config-wrapper">
            <div className="assigned-task-config-wrapper-card">
              <div className="card-title-wrap d-flex align-items-center">
                <div className="page-title">Assigned Task Configuration</div>

                <div className="checkpoint-id-holder">
                  Checkpoint ID-L0017997
                </div>
              </div>
              {/*--------------------------------- Step 1 --------------------------- */}
              <div className="card-body-wrap">
                <div>
                  <div className="header-text-wrapper d-flex align-items-center">
                    <AssignedTaskImpactSvgComponent size={18} />
                    <p className="header_text">Step 1 - Impact</p>
                  </div>
                  {/* <p className="header_text">Step 1 - Impact</p> */}

                  <div className="assigned-task-config-field-holder dropdown-select-no-line-on-dd">
                    <div className="grid">
                      <div className="grid-item">
                        <label htmlFor="law" className="label">
                          Impact On Vertical{" "}
                          <span className="form-label-error">*</span>
                        </label>
                        <div>
                          <SearchableDropdownSelect
                            placeholder={"Choose Impact On Vertical"}
                            options={impactOnVerticalList}
                            searchLoading={eventLoading}
                            handleChange={(val: any) =>
                              getImpactOnVerticalList(val)
                            }
                            handleClick={(e: any) =>
                              handleChangeSelect(e, "impact_on_vertical")
                            }
                            value={
                              getValue(impactOnVerticalList, `length`, 0) > 0
                                ? impactOnVerticalList.filter(
                                    (item: any) =>
                                      item.id ===
                                      getValue(
                                        request,
                                        `impact_on_vertical`,
                                        ""
                                      )
                                  )[0]
                                : ""
                            }
                            label="label"
                            id="id"
                            name="Impact On Vertical"
                            validator={simpleValidator}
                          />
                        </div>
                      </div>
                      <div className="grid-item">
                        <label htmlFor="law" className="label">
                          Impact On Unit{" "}
                          <span className="form-label-error">*</span>
                        </label>
                        <div>
                          <SearchableDropdownSelect
                            placeholder={"Choose Impact On Unit"}
                            options={impactOnUnitList}
                            searchLoading={impactOnUnitLoading}
                            handleChange={(val: any) =>
                              getImpactOnUnitList(val)
                            }
                            handleClick={(e: any) =>
                              handleChangeSelect(e, "impact_on_unit")
                            }
                            value={
                              getValue(impactOnUnitList, `length`, 0) > 0
                                ? impactOnUnitList.filter(
                                    (item: any) =>
                                      item.id ===
                                      getValue(request, `impact_on_unit`, "")
                                  )[0]
                                : ""
                            }
                            label="label"
                            id="id"
                            name="Impact On Unit"
                            validator={simpleValidator}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid">
                      <div className="grid-item">
                        <label htmlFor="law" className="label">
                          Impact <span className="form-label-error">*</span>
                        </label>
                        <div>
                          <SearchableDropdownSelect
                            placeholder={"Choose Impact"}
                            options={impactList}
                            searchLoading={impactLoading}
                            handleChange={(val: any) => getImpactList(val)}
                            handleClick={(e: any) =>
                              handleChangeSelect(e, "impact")
                            }
                            value={
                              getValue(impactList, `length`, 0) > 0
                                ? impactList.filter(
                                    (item: any) =>
                                      item.id ===
                                      getValue(request, `impact`, "")
                                  )[0]
                                : ""
                            }
                            label="label"
                            id="id"
                            name="Impact"
                            validator={simpleValidator}
                          />
                        </div>
                      </div>
                      <div className="user-details-wrapper__form-group-new form-group grid-item">
                        <label htmlFor="law" className="label">
                          &nbsp;
                        </label>
                        <div
                          className="list-managemnet-wrapper__country-items-alter d-flex align-items-center"
                          // style={{ marginRight: "22px" }}
                        >
                          <div className="position-relative w-100">
                            <input
                              type="text"
                              placeholder="Document Required"
                              className="form-control"
                              name="email1"
                              id="email1"
                              value={"Document Required"}
                              disabled
                              style={{ backgroundColor: "white" }}
                              autoComplete="off"
                            />
                            <div
                              className="vendor-profile-switch vendor-profile-switch--position custom-switch-wrapper-blue custom-switch-wrapper-icons"
                              style={{ marginTop: "5px" }}
                            >
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={getValue(
                                    request,
                                    `document_required`,
                                    false
                                  )}
                                  onChange={() =>
                                    setRequest({
                                      ...request,
                                      document_required: !request.document_required,
                                    })
                                  }
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="d-flex"> */}

                  {/* <div className="user-details-wrapper__form-group-new form-group mt-4">
                    <div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center">
                      <div className="position-relative">
                        <input
                          type="text"
                          placeholder="History Required"
                          className="form-control"
                          name="email1"
                          id="email1"
                          value={""}
                          //   onChange={(e: any) => handleChangeText(e)}
                          style={{ backgroundColor: "white" }}
                          //   validator={simpleValidator}
                          disabled
                        />
                        <div
                          className="vendor-profile-switch vendor-profile-switch--position custom-switch-wrapper-blue custom-switch-wrapper-icons"
                          style={{ marginTop: "5px" }}
                        >
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={getValue(
                                request,
                                `history_required`,
                                false
                              )}
                              onChange={() =>
                                setRequest({
                                  ...request,
                                  history_required: !request.history_required,
                                })
                              }
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* </div> */}
                  {/* <p className="header_text__desc mt-3">
                  If the task contains sub-task, enable the below option
                </p>
                <div className="d-flex grid mt-3">
                  {subTaskList.map((item: any) => {
                    return (
                      <div className="grid-item d-flex align-items-center">
                        <input
                          type={"radio"}
                          className="radio"
                          checked={
                            getValue(request, `task_type`, "") ===
                            getValue(item, `value`, "")
                          }
                          onChange={() =>
                            setRequest({ ...request, task_type: item.value })
                          }
                        />
                        <label
                          className="radio-label"
                          onClick={() =>
                            setRequest({ ...request, task_type: item.value })
                          }
                        >
                          {getValue(item, `label`, "")}
                        </label>
                      </div>
                    );
                  })}
                  {simpleValidator && (
                    <span className="form-error">
                      {simpleValidator.current.message(
                        "Task Type",
                        getValue(request, `task_type`, ""),
                        "required"
                      )}
                    </span>
                  )}
                </div> */}
                </div>

                {getValue(request, `task_type`, "") === "STANDARD" && (
                  <>
                    {/*--------------------------------- Step 2 --------------------------- */}

                    <div className="">
                      {/* mt-5 */}
                      <div className="header-text-wrapper d-flex align-items-center">
                        <AssignedTaskFrequencySvgComponent size={18} />
                        <p className="header_text">Step 2 - Frequency</p>
                      </div>
                      {/* <p className="header_text mt-3">Step 2</p> */}
                      <p className="header_text__desc">
                        {/* Lorem Ipsum is simply dummy text of the printing */}
                      </p>
                      <div className="assigned-task-config-field-holder">
                        <div className="d-flex grid">
                          <div className="user-details-wrapper__form-group form-group input-grid-item mb-0">
                            <label className="checkpoint-active-details__label">
                              Legal Due Date{" "}
                              <span className="form-label-error">*</span>
                            </label>
                            <div className="position-relative">
                              <label onClick={(e) => e.preventDefault()}>
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="form-control release-date-wrapper__vendor-form-control--calendar"
                                  placeholderText="Enter Legal Due Date"
                                  minDate={new Date()}
                                  value={getValue(
                                    request,
                                    `legal_due_date`,
                                    null
                                  )}
                                  disabled
                                  label="Legal Due Date"
                                  validator={simpleValidator}
                                />
                                <img
                                  src="/images/calander-grey.svg"
                                  className="img-fluid form-image form-image--calender"
                                />
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex grid">
                          <div className="input-grid-item input-grid-item-full-width">
                            <label className="checkpoint-active-details__label label">
                              Frequency
                            </label>

                            <div className="frequency-button-wrapper">
                              <button
                                // type="text"
                                className="form-control frequency-button"
                                // placeholder="Enter Frequency"
                                // value={getValue(request, `legal_due_date`, null)}
                                style={{ height: "41px" }}
                                onClick={handleModal}
                              >
                                {/* <img
                                  src="/images/checkpoint/frequency.svg"
                                  className="configure-wrapper__frequency-icon img-fluid"
                                  alt="test"
                                /> */}

                                {getValue(request, `frequency_type`, null) &&
                                  getValue(request, `frequency_type`, null)
                                    .charAt(0)
                                    .toUpperCase() +
                                    getValue(request, `frequency_type`, null)
                                      .slice(1)
                                      .toLowerCase()}
                                <span className="arrow-holder"></span>

                                {getValue(request, `frequency_type`, null) &&
                                  getValue(request, `new_activity_range`, null)
                                    .charAt(0)
                                    .toUpperCase() +
                                    getValue(
                                      request,
                                      `new_activity_range`,
                                      null
                                    )
                                      .slice(1)
                                      .toLowerCase()}
                                <span className="arrow-holder"></span>

                                {/* Once in Every (
                                {getValue(request, `once_in_every`, null)} &nbsp;
                                {getValue(request, 'new_activity_range', null).toLowerCase() === "monthly" ? "Month" : 
                                (getValue(request, 'new_activity_range', null).toLowerCase() === "yearly" ? "Year" :
                                (getValue(request, 'new_activity_range', null).toLowerCase() === "weekly" ? "Week" : ""))})                              
                                <span className="arrow-holder"></span> */}

                                {getValue(request, `once_in_every`, null) !==
                                  null && (
                                  <>
                                    Once in Every (
                                    {getValue(request, `once_in_every`, null)}{" "}
                                    &nbsp;
                                    {getValue(
                                      request,
                                      "new_activity_range",
                                      null
                                    ).toLowerCase() === "monthly"
                                      ? "Month"
                                      : getValue(
                                          request,
                                          "new_activity_range",
                                          null
                                        ).toLowerCase() === "yearly"
                                      ? "Year"
                                      : getValue(
                                          request,
                                          "new_activity_range",
                                          null
                                        ).toLowerCase() === "weekly"
                                      ? "Week"
                                      : getValue(
                                          request,
                                          "new_activity_range",
                                          null
                                        ).toLowerCase() === "daily"
                                      ? "Day"
                                      : ""}
                                    )
                                  </>
                                )}

                                {getValue(
                                  request,
                                  `new_activity_range`,
                                  null
                                ) !== "DAILY" && (
                                  <>
                                    <span className="arrow-holder"></span>
                                  </>
                                )}
                                {/* On ( {getValue(request, `on_month`, null)}) */}
                                {/* On ({getValue(request, `on_month`, null) === "1" ? getMonthLabel(getValue(request, `on_month`, null)) : getValue(request, `on_month`, null)}) */}

                                {/* On ({getMonthLabel(getValue(request, `on_month`, null))})
                                <span className="arrow-holder"></span> */}

                                {/* {getValue(request, `on_month`, null) !== null && (
                                    <>
                                        On ({getMonthLabel(getValue(request, `on_month`, null))})
                                        <span className="arrow-holder"></span>
                                    </>
                                )} */}

                                {getValue(request, `on_month`, null) !== null &&
                                  getValue(
                                    request,
                                    `new_activity_range`,
                                    null
                                  ) !== "DAILY" &&
                                  getValue(
                                    request,
                                    `new_activity_range`,
                                    null
                                  ) !== "WEEKLY" &&
                                  getValue(
                                    request,
                                    `new_activity_range`,
                                    null
                                  ) !== "MONTHLY" && (
                                    <>
                                      On (
                                      {getMonthLabel(
                                        getValue(request, `on_month`, null)
                                      )}
                                      )<span className="arrow-holder"></span>
                                    </>
                                  )}

                                {/* On (
                                {getValue(request, `on_day`, null)}) Day */}

                                {getValue(request, `on_day`, null) !== null &&
                                  getValue(
                                    request,
                                    `new_activity_range`,
                                    null
                                  ) !== "DAILY" && (
                                    <>
                                      On ({getValue(request, `on_day`, null)})
                                      Day
                                    </>
                                  )}
                              </button>
                              <div className="frequency-button-edit-icon">
                                <EditGreySvgComponent />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*--------------------------------- Step 3 --------------------------- */}
                    <div className="">
                      {/* mt-5 */}
                      {/* <p className="header_text mt-3">Step 3</p> */}
                      <div className="header-text-wrapper d-flex align-items-center">
                        <AssignedTaskDueDateSvgComponent size={18} />
                        <p className="header_text">Step 3 - Due Dates</p>
                      </div>
                      <p className="header_text__desc mt-3 mb-3">
                        {/* Lorem Ipsum is simply dummy text of the printing */}
                      </p>

                      <div className="assigned-task-config-field-holder">
                        <div className="d-flex grid">
                          <div className="input-grid-item mb-0">
                            <label className="checkpoint-active-details__label">
                              Days Buffer (Days){" "}
                              <span className="form-label-error">*</span>
                            </label>
                            <InputField
                              inputType="NUMBER"
                              className="form-control"
                              placeholder="Enter Days Buffer"
                              value={getValue(request, `days_buffer`, null)}
                              onChange={(e: any) =>
                                handleRequest(e, "days_buffer")
                              }
                              // validator={getValue(request, `task_type`, "") === "STANDARD"?simpleValidator:null}
                              label={"Days Buffer"}
                              disabled={
                                !getValue(request, `legal_due_date`, "")
                              }
                              validator={simpleValidator}
                            />
                          </div>

                          {/* <div className="user-details-wrapper__form-group form-group input-grid-item">
                          <label className="checkpoint-active-details__label">
                            Unit Head Due Date
                          </label>
                          <div className="position-relative">
                            <label onClick={(e) => e.preventDefault()}>
                              <InputField
                                inputType="DATETYPE-DOB"
                                className="form-control release-date-wrapper__vendor-form-control--calendar"
                                placeholderText="Enter Unit Head Due Date"
                                minDate={new Date()}
                                value={getValue(
                                  request,
                                  `unit_head_due_date`,
                                  null
                                )}
                                disabled
                              />
                              <img
                                src="/images/calander-grey.svg"
                                className="img-fluid form-image form-image--calender"
                              />
                            </label>
                          </div>
                        </div> */}

                          <div className="user-details-wrapper__form-group form-group input-grid-item mb-0">
                            <label className="checkpoint-active-details__label ms-0">
                              Function Head Due Date{" "}
                              <span className="form-label-error">*</span>
                            </label>
                            <div className="position-relative">
                              <label
                                onClick={(e) => e.preventDefault()}
                                className="ms-0"
                              >
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="form-control release-date-wrapper__vendor-form-control--calendar"
                                  placeholderText="Enter Function Head Due Date"
                                  minDate={new Date()}
                                  value={getValue(
                                    request,
                                    `function_head_due_date`,
                                    null
                                  )}
                                  label={"Function Head Due Date"}
                                  disabled
                                  validator={simpleValidator}
                                />
                                <img
                                  src="/images/calander-grey.svg"
                                  className="img-fluid form-image form-image--calender"
                                />
                              </label>
                            </div>
                          </div>
                          <div className="user-details-wrapper__form-group form-group input-grid-item mb-0">
                            <label className="checkpoint-active-details__label ms-0">
                              Evaluator(Approver) Due Date{" "}
                              <span className="form-label-error">*</span>
                            </label>
                            <div className="position-relative">
                              <label
                                onClick={(e) => e.preventDefault()}
                                className="ms-0"
                              >
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="form-control release-date-wrapper__vendor-form-control--calendar"
                                  placeholderText="Enter Approver Due Date"
                                  minDate={new Date()}
                                  value={getValue(
                                    request,
                                    `approver_due_date`,
                                    null
                                  )}
                                  disabled
                                  validator={simpleValidator}
                                  label={"Evaluator Due Date"}
                                />
                                <img
                                  src="/images/calander-grey.svg"
                                  className="img-fluid form-image form-image--calender"
                                />
                              </label>
                            </div>
                          </div>
                          <div className="user-details-wrapper__form-group form-group input-grid-item mb-0">
                            <label className="checkpoint-active-details__label ms-0">
                              Executor(Owner) Due Date{" "}
                              <span className="form-label-error">*</span>
                            </label>
                            <div className="position-relative">
                              <label
                                onClick={(e) => e.preventDefault()}
                                className="ms-0"
                              >
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="form-control release-date-wrapper__vendor-form-control--calendar"
                                  placeholderText="Enter Owner Due Date"
                                  minDate={new Date()}
                                  value={getValue(
                                    request,
                                    `owner_due_date`,
                                    null
                                  )}
                                  disabled
                                  validator={simpleValidator}
                                  label={"Executor Due Date"}
                                />
                                <img
                                  src="/images/calander-grey.svg"
                                  className="img-fluid form-image form-image--calender"
                                />
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex grid">
                          <div className="user-details-wrapper__form-group-new  input-grid-item">
                            <div
                              className="list-managemnet-wrapper__country-items-alter"
                              // style={{ marginRight: "22px" }}
                            >
                              <div>
                                <label className="checkpoint-active-details__label label">
                                  Others
                                </label>
                              </div>
                              <div className="position-relative w-100">
                                <input
                                  type="text"
                                  placeholder="Back Date Allowed"
                                  className="form-control"
                                  name="email1"
                                  id="email1"
                                  value={""}
                                  autoComplete="off"
                                  disabled
                                  style={{ backgroundColor: "white" }}
                                />
                                <div
                                  className="vendor-profile-switch vendor-profile-switch--position custom-switch-wrapper-blue custom-switch-wrapper-icons"
                                  style={{ marginTop: "5px" }}
                                >
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={getValue(
                                        request,
                                        `back_dates_allowed`,
                                        false
                                      )}
                                      onChange={() =>
                                        setRequest({
                                          ...request,
                                          back_dates_allowed: !request.back_dates_allowed,
                                        })
                                      }
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="user-details-wrapper__form-group-new  input-grid-item">
                            <label className="checkpoint-active-details__label label">
                              &nbsp;
                            </label>
                            <div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center">
                              <div
                                className="position-relative w-100"
                                // style={{ marginRight: "22px" }}
                              >
                                <input
                                  type="text"
                                  placeholder="Task Maker Checker Allowed"
                                  className="form-control"
                                  name="email1"
                                  id="email1"
                                  value={""}
                                  autoComplete="off"
                                  //   onChange={(e: any) => handleChangeText(e)}
                                  style={{ backgroundColor: "white" }}
                                  //   validator={simpleValidator}
                                  disabled
                                />
                                <div
                                  className="vendor-profile-switch vendor-profile-switch--position custom-switch-wrapper-blue custom-switch-wrapper-icons"
                                  style={{ marginTop: "5px" }}
                                >
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={getValue(
                                        request,
                                        `task_maker_checker_allowed`,
                                        false
                                      )}
                                      onChange={() =>
                                        setRequest({
                                          ...request,
                                          task_maker_checker_allowed: !request.task_maker_checker_allowed,
                                        })
                                      }
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="user-details-wrapper__form-group-new input-grid-item">
                            <div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center">
                              <div className="position-relative w-100">
                                <input
                                  type="text"
                                  placeholder="Enable Audit Step"
                                  className="form-control"
                                  name="email1"
                                  id="email1"
                                  value={""}
                                  autoComplete="off"
                                  //   onChange={(e: any) => handleChangeText(e)}
                                  style={{ backgroundColor: "white" }}
                                  //   validator={simpleValidator}
                                  disabled
                                />
                                <div
                                  className="vendor-profile-switch vendor-profile-switch--position custom-switch-wrapper-blue custom-switch-wrapper-icons"
                                  style={{ marginTop: "5px" }}
                                >
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={getValue(
                                        request,
                                        `enable_audit_step`,
                                        false
                                      )}
                                      onChange={() =>
                                        setRequest({
                                          ...request,
                                          enable_audit_step: !request.enable_audit_step,
                                        })
                                      }
                                    />
                                    <span className="slider round"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex grid">
                          <div className="input-grid-item">
                            <label className="checkpoint-active-details__label">
                              Email Buffer Days{" "}
                              <span className="form-label-error">*</span>
                            </label>
                            <InputField
                              inputType="NUMBER"
                              className="form-control"
                              placeholder="Enter Email Buffer Days"
                              value={getValue(
                                request,
                                `email_buffer_days`,
                                null
                              )}
                              // onChange={(e: any) =>
                              // 	setRequest({
                              // 		...request,
                              // 		email_buffer_days: getValue(e, `target.value`, ""),
                              // 	})
                              // }
                              onChange={(e: any) =>
                                handleRequest(e, "email_buffer_days")
                              }
                              label={"Email Buffer Days"}
                              validator={simpleValidator}
                              // validator={getValue(request, `task_type`, "") === "STANDARD"?simpleValidator:null}
                            />
                          </div>
                        </div>
                      </div>

                      {/* <div className="grid"> */}
                      {/* <div className="user-details-wrapper__form-group form-group input-grid-item-individual">
                        <label className="checkpoint-active-details__label">
                          Audit Date
                        </label>
                        <div className="position-relative">
                          <label onClick={(e) => e.preventDefault()}>
                            <InputField
                              inputType="DATETYPE-DOB"
                              className="form-control release-date-wrapper__vendor-form-control--calendar"
                              placeholderText="Enter Audit Date"
                              minDate={new Date()}
                              value={getValue(request, `audit_date`, null)}
                              disabled
                            />
                            <img
                              src="/images/calander-grey.svg"
                              className="img-fluid form-image form-image--calender"
                            />
                          </label>
                        </div>
                      </div> */}
                      {/* </div> */}

                      {/*--------------------------------- Additional Alerts --------------------------- */}
                      {/* <label
                      className="position-relative form-group d-flex align-items-center cursor-pointer mt-4 mb-4"
                      htmlFor={`select-1-z2`}
                      key={`select-1-z2`}
                    >
                      <div>
                        <input
                          type="checkbox"
                          className="default-checkbox"
                          id={`select-1-z2`}
                          checked={additionalAlert}
                          onChange={() => setAdditionalAlert(!additionalAlert)}
                          // onChange={() =>
                          // 	handleSelectAll(
                          // 		getValue(allList, `length`, 0) ===
                          // 			getValue(selectedPermissions, `length`, 0)
                          // 			? "false"
                          // 			: "true"
                          // 	)
                          // }
                          // checked={
                          // 	getValue(selectedPermissions, `length`, 0) > 0 &&
                          // 	getValue(allList, `length`, 0) ===
                          // 		getValue(selectedPermissions, `length`, 0)
                          // }
                        />
                        <div className="custom-checkbox--bg-blue">
                          <img
                            src="/images/uploaded-details/tick.svg"
                            className="img-fluid uploaded-tick"
                          />
                        </div>
                      </div>
                      <h6 className="mx-3"> {"Additional Alerts Required"}</h6>
                    </label>
                    {additionalAlert && (
                      <div className="grid">
                        {alertDates.map((item, index) => {
                          return (
                            <div className="user-details-wrapper__form-group form-group input-grid-item-individual">
                              <label className="checkpoint-active-details__label">
                                {getValue(item, `label`, "")}
                              </label>
                              <div className="position-relative">
                                <label onClick={(e) => e.preventDefault()}>
                                  <InputField
                                    inputType="DATETYPE-DOB"
                                    className="form-control release-date-wrapper__vendor-form-control--calendar"
                                    placeholderText={`Enter ${getValue(
                                      item,
                                      `label`,
                                      ""
                                    )}`}
                                    value={getValue(item, `date`, null)}
                                    onChange={(e: any) => handleDate(e, index)}
                                    minDate={new Date()}
                                  />
                                  <img
                                    src="/images/calander-grey.svg"
                                    className="img-fluid form-image form-image--calender"
                                  />
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )} */}
                    </div>
                  </>
                )}
              </div>

              <div className="card-footer-wrap">
                <button
                  className="ascent-button ascent-button--header-buttons ascent-button--secondary margin-right-8"
                  onClick={handleSubmit}
                  disabled={submitLoading}
                >
                  {submitLoading ? "Please wait..." : "Submit"}
                </button>

                <button
                  className="ascent-button ascent-button--header-buttons ascent-button--primary"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <ConfigurePopup
        isOpen={isOpen}
        handleModal={handleModal}
        selectedIDs={[]}
        request={request}
        setRequest={setRequest}
        handleRequest={handleRequestCalculateDate}
      />
    </DashboardLayout>
  );
};

export default ICAssignedTaskConfiguration;
